import React from 'react'
import { Tooltip, IconButton } from '@mui/material/'

export default function IconBtn({ Icon, className, onClick, title, size, sx = {} }) {
  return (
    <Tooltip title={title}>
      <IconButton onClick={onClick} size={size} className={className} sx={sx}>
        <Icon className={className} />
      </IconButton>
    </Tooltip>
  )
}
